import { Avatar, Stack, Typography } from '@datanomik/commons-ui';
import React from 'react';

type ActionRowProps = {
  icon: React.ReactNode;
  color: string;
  title: string;
  subtitle?: string;
  actions: React.ReactNode[];
};

export const ActionRow = (props: ActionRowProps) => {
  const {
    icon, title, subtitle, actions, color,
  } = props;

  const coloredIcon = React.cloneElement(icon as React.ReactElement, {
    style: { color },
  });

  return (
    <Stack direction="row" alignItems="center" gap={2} sx={{ padding: '16px' }}>
      <Stack direction="row" alignItems="center" gap={1} flex={1}>
        <Avatar sx={{
          backgroundColor: `${color}.lighter`,
        }}
        >
          {coloredIcon}
        </Avatar>
        <Stack flex={1}>
          <Typography fontWeight="500" fontSize="13px">
            {title}
          </Typography>
          {subtitle && <span style={{ fontSize: '12px', color: 'text.secondary' }}>{subtitle}</span>}
        </Stack>
      </Stack>
      <Stack direction="row" spacing={1} ml="auto">
        {actions.map((action, index) => (

          <div key={`action-${index}`}>{action}</div>
        ))}
      </Stack>
    </Stack>
  );
};
